import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(0, 3.75, 2),
  },
  actions: {
    padding: theme.spacing(0.75, 0),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1, 1),
  },
  table: {
    flexGrow: 1,
    margin: theme.spacing(2, 0, 0),
  },
}));
